<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template>
            <el-input
                clearable
                v-model="search.email"
                clas="input_search"
                placeholder="用户邮箱"
                style="margin-right: 10px"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-select
                v-model="search.status"
                clearable
                filterable
                placeholder="订阅状态"
            >
              <el-option label="CREATE" value="CREATE"></el-option>
              <el-option label="APPROVED" value="APPROVED"></el-option>
              <el-option label="CANCELED" value="CANCELED"></el-option>
            </el-select>

            <el-input
                clearable
                v-model="search.paymentType"
                clas="input_search"
                placeholder="支付类型"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.paymentWay"
                clas="input_search"
                placeholder="支付方式"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.channelAccountId"
                clas="input_search"
                placeholder="渠道账户ID"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.channelType"
                clas="input_search"
                placeholder="渠道类型"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.appExamId"
                clas="input_search"
                placeholder="应用考试ID"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.examId"
                clas="input_search"
                placeholder="考试ID"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-input
                clearable
                v-model="search.examInfoId"
                clas="input_search"
                placeholder="考试信息ID"
                style="margin-right: 10px;margin-bottom: 10px;"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <div
                class="block timeblock"
                style="width: 400px; margin-bottom: 10px"
            >
              <el-select
                  v-model="search.dateType"
                  clearable
                  placeholder="选择时间"
                  style="margin: 0"
              >
                <el-option
                    v-for="item in SUBSCRIPTION_TIME_TYPE"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                ></el-option>
              </el-select>
              <el-date-picker
                  v-model="value2"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </div>

            <el-button size="medium" type="primary" @click="getserviceList(1)"
            >查询
            </el-button
            >
          </template>

          <el-button
              size="medium"
              type="primary"
              @click="upserviceList"
          >下载
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="id"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                    (page.current - 1) * page.size + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="用户邮箱"
                min-width="180"
                prop="email"
            >
            </el-table-column>
            <el-table-column
                label="支付类型"
                min-width="120"
                prop="paymentType"
            ></el-table-column>
            <el-table-column
                label="原始支付方式"
                min-width="120"
                prop="originalPaymentWay"
            ></el-table-column>
            <el-table-column
                label="支付方式"
                min-width="120"
                prop="paymentWay"
            ></el-table-column>
            <el-table-column
                label="开始日期"
                min-width="160"
                prop="startDate"
            ></el-table-column>
            <el-table-column
                label="SKU试用天数"
                min-width="120"
                prop="skuTrialDays"
            ></el-table-column>
            <el-table-column
                label="试用期结束日期"
                min-width="160"
                prop="trialEndDate"
            ></el-table-column>
            <el-table-column
                label="下次支付日期"
                min-width="160"
                prop="nextBillingDate"
            ></el-table-column>
            <el-table-column
                label="取消时间"
                min-width="160"
                prop="cancelDate"
            ></el-table-column>
            <el-table-column
                label="订阅状态"
                min-width="100"
                prop="status"
            >
              <template slot-scope="scope">
                <span
                    :style="
                      scope.row.status == 'ACTIVE' ? 'color: #28AB80' : 
                      scope.row.status == 'CANCELLED' ? 'color: #F56C6C' : ''
                    "
                >{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="应用考试ID"
                min-width="120"
                prop="appExamId"
            ></el-table-column>
            <el-table-column
                label="考试ID"
                min-width="120"
                prop="examId"
            ></el-table-column>
            <el-table-column
                label="考试信息ID"
                min-width="120"
                prop="examInfoId"
            ></el-table-column>
            <el-table-column
                label="支付金额"
                width="100"
                prop="payPrice"
            >
              <template slot-scope="scope">
                $ {{ scope.row.payPrice }}
              </template>
            </el-table-column>
            <el-table-column
                label="SKU试用价格"
                min-width="120"
                prop="skuTrialPrice"
            ></el-table-column>
            <el-table-column
                label="SKU价格"
                min-width="120"
                prop="skuPrice"
            ></el-table-column>
            <el-table-column
                label="SKU周期"
                min-width="120"
                prop="skuCycle"
            ></el-table-column>
            <el-table-column
                label="渠道账户ID"
                min-width="120"
                prop="channelAccountId"
            ></el-table-column>
            <el-table-column
                label="渠道类型"
                min-width="120"
                prop="channelType"
            ></el-table-column>
            <el-table-column
                label="渠道账户"
                min-width="120"
                prop="account"
            ></el-table-column>
            <el-table-column
                label="支付编码"
                min-width="120"
                prop="payCode"
            ></el-table-column>
            <el-table-column
                label="订单号"
                min-width="120"
                prop="orderNumber"
            ></el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {PAGE_SIZE, SUBSCRIPTION_TIME_TYPE,} from "@/config";

import {isEmpty}      from "@utils/tools/index";
import {downloadFile} from "@/utils/filters/upload.js";

export default {
  data() {
    return {
      PAGE_SIZE,
      SUBSCRIPTION_TIME_TYPE,
      isEmpty,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "", //以上时间选择器

      // 分页
      page: {
        current: 1,
        size: PAGE_SIZE,
      },
      tableData: [], //订阅列表

      loading: false,

      search: {},
      searchShow: false,
      downShow: false,
    };
  },
  created() {
    this.getserviceList();
  },
  watch: {},
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem(
          "TaotanPermissionButton"
      );

      // 确保 PermissionButtonList 存在且能被解析为数组
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          if (Array.isArray(arr)) {
            arr.map((item) => {
              if (item.code == "order:subscription:query") {
                this.searchShow = true;
              }
              if (item.code == "order:subscription:down") {
                this.downShow = true;
              }
            });
          }
        } catch (e) {
          console.error("解析权限按钮列表失败:", e);
        }
      }
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.dateType == undefined || this.search.dateType == "") {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }

        // 只使用开始日期范围查询
        this.search.startDateFrom = this.value2[0];
        this.search.startDateTo = this.value2[1];
      }
      if (this.search.dateType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }

      // 移除空属性
      this.removeEmptyProperties(this.search);

      // 构建查询参数
      let queryString = "";
      for (const key in this.search) {
        if (this.search.hasOwnProperty(key) && this.search[key]) {
          queryString += `${key}=${this.search[key]}&`;
        }
      }
      // 移除字符串末尾的多余的 '&' 符号
      queryString = queryString.slice(0, -1);

      // 如果有时间筛选条件，则执行导出
      if (queryString.includes('From') && queryString.includes('To')) {
        const downloadUrl = `/taotan_admin_api/api/subscriptions/export?${queryString}`;
        downloadFile(downloadUrl, `subscription_${new Date().getTime()}.csv`);
      } else if (!this.search.dateType) {
        // 没有时间筛选条件也允许导出
        const downloadUrl = `/taotan_admin_api/api/subscriptions/export?${queryString}`;
        downloadFile(downloadUrl, `subscription_${new Date().getTime()}.csv`);
      } else {
        this.$message.warning("请选择完整的时间范围");
      }
    },

    //订阅列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.current = 1;
      }

      if (this.value2 && this.value2.length) {
        if (this.search.dateType == undefined || this.search.dateType == "") {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }

        // 只使用开始日期范围查询
        this.search.startDateFrom = this.value2[0];
        this.search.startDateTo = this.value2[1];
      } else {
        // 清除时间相关字段
        delete this.search.startDateFrom;
        delete this.search.startDateTo;
        delete this.search.dateType;
      }

      if (this.search.dateType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }

      this.loading = true;
      this.removeEmptyProperties(this.search);

      const {data: res} = await this.$get(
          `/api/subscriptions/list-view`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );

      this.loading = false;
      let list = res.data.records;
      this.tableData = list;
      this.page.total = res.data.total;
    },
    removeEmptyProperties(obj) {
      for (const key in obj) {
        if (
            obj.hasOwnProperty(key) &&
            (obj[key] === null || obj[key] === undefined || obj[key] === "")
        ) {
          delete obj[key];
        }
      }
    },

    //分页
    handleSizeChange(val) {
      this.page.size = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.el-select {
  margin-bottom: 10px;
  margin-right: 10px;
}
</style>
